<template>
  <v-container fluid fill-height align-start ma-0 pa-0>
    <i-dxpopup
      :popupVisible="popupVisible"
      :title="popupTitle"
      @popupCloseButtonClick="popupCloseButtonClick"
      :vHtmlContent="'test'"
      :height="'600'"
      :width="'700'"
    >
      <template v-slot:image>
        <v-img id="imageLoader" :src="require('@/assets/images/etc/imageLoading.png')" contain></v-img>
        <img id="popupImageContent" class="popupImage" />
      </template>
    </i-dxpopup>
    <v-row no-gutters>
      <v-col cols="12" sm="12" lg="12" class="pa-0 py-2 pt-7">
        <prepareTextArea
          :title="`8. ${$t('promotionProcedure')}`"
          :content="sampleTempleteResource.promotion_procedure"
          :rows="17"
          :inputValue="input_promotion_procedure"
          :disabled="disabled"
        >
          <template v-slot:add>
            <div class="addStyle align-center float-right mr-1 d-md-inline-flex d-inline-block">
              <div class="d-flex align-center justify-end">
                <span class="font-weight-bold caption mx-2 secondary--text">{{ $t('riskCriteria') }}: </span>
                <v-select
                  :menu-props="{ offsetY: true }"
                  color="primary"
                  class="mx-1 search-select"
                  item-text="minorNm"
                  item-value="minorCd"
                  :prepend-inner-icon="$t('$search')"
                  :items="riskCalcStandardList"
                  label=""
                  dense
                  outlined
                  v-model="risk_estimation"
                />
              </div>
              <div class="mt-2 mt-md-0">
                <v-btn
                  class="rounded ml-1 font-weight-bold"
                  height="28"
                  elevation="0"
                  small
                  color="btn_thi"
                  @click="ShowPopup('RiskProcedure', { targetId: 'RAP' })"
                >
                  {{ $t('riskProcedure') }}
                </v-btn>

                <v-btn
                  class="rounded ml-1"
                  height="28"
                  elevation="0"
                  small
                  color="btn_thi"
                  @click="ShowPopup('Possibility', { targetId: risk_estimation == '3b3' ? 'RP3' : 'RP5' })"
                >
                  {{ $t('possibility') }}
                </v-btn>
                <v-btn
                  class="rounded ml-1"
                  height="28"
                  elevation="0"
                  small
                  color="btn_thi"
                  @click="ShowPopup('Importance', { targetId: risk_estimation == '3b3' ? 'RI3' : 'RI5' })"
                >
                  {{ $t('importance') }}
                </v-btn>
                <v-btn
                  class="rounded ml-1"
                  height="28"
                  elevation="0"
                  small
                  color="btn_thi"
                  @click="ShowPopup('RiskCalculation', { targetId: risk_estimation == '3b3' ? 'RE3' : 'RE5' })"
                >
                  {{ $t('riskCalculation') }}
                </v-btn>
                <v-btn
                  class="rounded ml-1"
                  height="28"
                  elevation="0"
                  small
                  color="btn_thi"
                  @click="ShowPopup('RiskDecision', { targetId: risk_estimation == '3b3' ? 'RD3' : 'RD5' })"
                >
                  {{ $t('riskDecision') }}
                </v-btn>
              </div>
            </div>
          </template>
        </prepareTextArea>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import iDxPopup from '@/components/common/iDxPopup.vue'
//function
import { getCommonCode } from '@/api/common/commonApi'
import { downloadFilebySystemCode } from '@/api/baseManage/fileUpload'
//
import BasePreparation from './BasePreparation.vue' //20220414 LYJ base page 추가
let objectUrl = null
export default {
  extends: BasePreparation,
  components: { 'i-dxpopup': iDxPopup },
  props: {
    sampleTempleteResource: {
      type: Object,
      default: {}
    },
    sampleTempleteType: {
      type: String,
      default: () => ''
    },
    disabled: {
      default: false
    }
  },
  data() {
    return {
      //popup
      targetType: 'S0006',
      popupVisible: false,
      popupTitle: '',
      risk_estimation: undefined, //위험성 추정 기준
      promotion_procedure: '', //위험성 평가 추진 절차
      riskCalcStandardList: []
    }
  },
  mounted() {
    Promise.all([getCommonCode('S0002')])
      .then(response => {
        let failedResponse = response.find(element => !element.success)
        if (failedResponse == null) {
          this.riskCalcStandardList = response[0].list.slice()

          // console.log('riskCalcStandardList : ' + JSON.stringify(this.riskCalcStandardList))

          //console.log(this.risk_estimation)
          if (this.risk_estimation == undefined) this.risk_estimation = this.riskCalcStandardList ? this.riskCalcStandardList[0].minorCd : ''
        } else {
          //////////console.log(failedResponse.msg)
        }
      })
      .catch(error => {})
      .finally(() => {})
  },
  watch: {
    sampleTempleteType: function(value) {
      this.risk_estimation = this.sampleTempleteType
    }
  },
  methods: {
    input_promotion_procedure(value) {
      this.promotion_procedure = value
    },
    ShowPopup(title, fileInfo) {
      // document.getElementById('popupImageContent').src = require('@/assets/images/etc/imageLoading.png')
      //console.log(document.getElementById('popupImageContent'))
      if (document.getElementById('popupImageContent')) document.getElementById('popupImageContent').style.display = 'none'
      if (document.getElementById('imageLoader')) document.getElementById('imageLoader').style.display = 'block'
      this.popupTitle = this.$t(title)
      this.popupVisible = true
      downloadFilebySystemCode({ targetType: this.targetType, targetId: fileInfo.targetId }).then(res => {
        if (res.result.success) {
          //파일 뷰
          if (document.getElementById('imageLoader')) document.getElementById('imageLoader').style.display = 'none'
          if (document.getElementById('popupImageContent')) document.getElementById('popupImageContent').style.display = 'block'
          objectUrl = window.URL.createObjectURL(res)
          document.getElementById('popupImageContent').src = objectUrl
        }
      })
    },
    popupCloseButtonClick() {
      this.popupVisible = false
      // url 사용 후에 메모리에서 제거하기
      //document.getElementById('popupImageContent').style.display = 'none'
      console.log('메모리 해제')
      window.URL.revokeObjectURL(objectUrl)
    }
  }
}
</script>

<style lang="scss" scoped>
.addStyle {
  display: inline-flex;
}
.search-select {
  max-width: 150px;
  display: inline-block;
}

.popupImage {
  object-fit: cover;
  align-content: center;
  margin: auto;
}
</style>
